import { Button } from '@monorepo/shared/componentsV2/Button';
import { Checkbox } from '@monorepo/shared/componentsV2/Checkbox';
import { useTableBulkActions } from '@monorepo/shared/componentsV2/Table/useTableBulkActions';
import CheckboxIcon from '@svg/checkbox.svg';
import TrashIcon from '@svg/trash.svg';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 2.625rem;
`;

const BulkActionsButton = styled(Button)`
  margin-left: -0.5rem;
`;

const DeleteButton = styled(Button)`
  margin-right: 1rem;
`;

type TableBulkActionsProps = {
  className?: string;
  isBulkDeleting: boolean;
  onDelete: () => void;
};

export function TableBulkActions({
  className,
  isBulkDeleting,
  onDelete,
}: TableBulkActionsProps) {
  const {
    areAllVisibleSelected,
    areAnySelected,
    areAnyVisibleSelected,
    isBulkActionsModeOn,
    isBulkDeleteLimitExceeded,
    onToggleAllVisibleRows,
    selectedCount,
    turnBulkActionsModeOff,
    turnBulkActionsModeOn,
  } = useTableBulkActions();

  return (
    <Container className={className}>
      {!isBulkActionsModeOn ? (
        <BulkActionsButton onClick={turnBulkActionsModeOn}>
          <CheckboxIcon />
          Bulk actions
        </BulkActionsButton>
      ) : (
        <>
          <Checkbox
            checked={areAllVisibleSelected}
            disabled={isBulkDeleting}
            indeterminate={areAnyVisibleSelected && !areAllVisibleSelected}
            label={selectedCount ? `${selectedCount} selected` : 'Select all'}
            onChange={(evt) => onToggleAllVisibleRows(evt.target.checked)}
          />
          <DeleteButton
            color="secondary"
            disabled={
              isBulkDeleting || !areAnySelected || isBulkDeleteLimitExceeded
            }
            onClick={onDelete}
          >
            <TrashIcon />
            {isBulkDeleting ? 'Deleting...' : 'Delete'}
          </DeleteButton>
          <Button disabled={isBulkDeleting} onClick={turnBulkActionsModeOff}>
            Exit bulk actions
          </Button>
        </>
      )}
    </Container>
  );
}
